module.exports = __webpack_public_path__ + "img/item-image-fallback.e53d534a.svg";